import { render, staticRenderFns } from "./usersView.vue?vue&type=template&id=0087ab78&"
import script from "./usersView.vue?vue&type=script&lang=js&"
export * from "./usersView.vue?vue&type=script&lang=js&"
import style0 from "./usersView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports